import { render, staticRenderFns } from "./QuestionItem.vue?vue&type=template&id=29c640d4&scoped=true&"
import script from "./QuestionItem.vue?vue&type=script&lang=ts&"
export * from "./QuestionItem.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionItem.vue?vue&type=style&index=0&id=29c640d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c640d4",
  null
  
)

export default component.exports